import React from "react"
import clsx from "clsx"
import {
	PersonAdd
} from "@material-ui/icons"
import {
	Button,
	Typography
} from "@material-ui/core"

import { AlertContainer } from "@/components"
import {
	AlertType
} from "@/components/AlertContainer"

import { AttendantAutomaticUpsellBlockCode } from "@/pages/Admin/Attendant"
import { whatsappLinks } from "@/utils/link"

import { colors } from "@/styles/colors"
import useStyles from "@/pages/Admin/Attendant/components/UpsellAttendantAlertContainer/styles"
import ColorUtil from "@/utils/ColorUtil"

type UpsellAttendantAlertContainerProps = {
	attendantUpsellBlockCode: AttendantAutomaticUpsellBlockCode | null
}

export type UpsellAttendantButtonStyleProps = {
	backgroundColor: string
	borderColor: string
	textColor: string
	hoverColor: string
}

const ATTENDANTS_ALERT_UPSELL_DATA: Record<"user_reach_limit" | "user_is_reaching_the_limit", {
	title: string
	text: string
	upsellAlertType: Extract<AlertType, "info" | "warning">
}> = {
	user_is_reaching_the_limit: {
		title: "Contrate mais atendentes",
		text: "É possível que, em breve, você precise contratar mais atendentes. Caso prefira adiantar essa contratação, basta clicar no botão a frente.",
		upsellAlertType: "info"
	},
	user_reach_limit: {
		title: "Limite de atendentes atingido",
		text: "O limite de atendentes da sua conta foi atingido. Clique no botão a frente para fazer o upgrade agora mesmo!",
		upsellAlertType: "warning"
	}
}

const UpsellAttendantAlertContainer: React.FC<UpsellAttendantAlertContainerProps> = (props) => {
	const {
		attendantUpsellBlockCode
	} = props

	if (!attendantUpsellBlockCode) {
		return null
	}

	const attendantsAlertUpsellContent = ATTENDANTS_ALERT_UPSELL_DATA[attendantUpsellBlockCode]

	const getButtonStyleProps = (): UpsellAttendantButtonStyleProps => {
		const alertTypeToButtonStyleProps: Record<Extract<AlertType, "info" | "warning">, UpsellAttendantButtonStyleProps> = {
			info: {
				...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
				borderColor: colors.getPrimaryColor(),
				textColor: colors.getPrimaryColor(),
				hoverColor: colors.purple[50]
			},
			warning: {
				...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
				borderColor: colors.yellow[500],
				textColor: colors.yellow[500],
				hoverColor: colors.yellow[50]
			}
		}

		return alertTypeToButtonStyleProps[attendantsAlertUpsellContent.upsellAlertType]
	}

	const buttonStyleProps = getButtonStyleProps()

	const classes = useStyles(buttonStyleProps)

	return (
		<AlertContainer
			title={attendantsAlertUpsellContent.title}
			icon={
				<PersonAdd
					style={{
						color: attendantUpsellBlockCode === "user_is_reaching_the_limit" ? colors.getPrimaryColor() : colors.yellow[500],
						width: 32,
						height: 32
					}}
				/>
			}
			customButton={(
				<Button
					variant="outlined"
					className={clsx({
						[classes.button]: true,
						[classes.buttonPulseEffect]: attendantUpsellBlockCode === "user_reach_limit"
					})}
					onClick={() => window.open(whatsappLinks.sendMessageToUpgradeAttendantsLimit, "_blank")}
				>
					Fazer Upgrade
				</Button>
			)}
			alertType={attendantsAlertUpsellContent.upsellAlertType}
			customStyles={{
				info: {
					borderLeftColor: colors.getPrimaryColor(),
					containerBackgroundColor: colors.gray[0],
					titleColor: colors.getPrimaryColor()
				},
				warning: {
					borderLeftColor: colors.yellow[500],
					containerBackgroundColor: colors.gray[0],
					titleColor: colors.yellow[500]
				}
			}}
		>
			<Typography
				style={{
					fontSize: 12
				}}
			>
				{attendantsAlertUpsellContent.text}
			</Typography>
		</AlertContainer>
	)
}

export default UpsellAttendantAlertContainer
